import { GetterTree } from 'vuex';
import { IUserState } from './user-state.store';
import { IRootState } from '../root-state.store';
//@ts-ignore
import { ActivityStatus } from '@/common/enums';
import { IUserService } from '../../services';
import { IUserDetails } from '../../models/user';
import { UserTypes } from '../../common/enums';

export const getters: GetterTree<IRootState, IUserState> = {

  activityStatus: (state: IRootState): ActivityStatus => {
    return state.activityStatus;
  }
  , userInfo: (state: IUserState): IUserDetails => state.userInfo
  , isAdmin: (state: IUserState): Boolean => state.userInfo.type === UserTypes.Admin
  , isManager: (state: IUserState): Boolean => state.userInfo.type === UserTypes.Manager
  , service: (state: IUserState): IUserService => state.service
  , modules: (state: IUserState): IUserService => state.modules
  , isTenantOrSale: (state: IUserState): boolean => {
    return state.userInfo.type === UserTypes.Tenant
      || state.userInfo.type === UserTypes.SalesPerson;
  }
  , canAskAppointment: (state: IUserState): boolean => {
    return state.userInfo.type === UserTypes.Tenant
      || state.userInfo.type === UserTypes.SalesPerson
      || state.userInfo.type === UserTypes.Caretaker
      || state.userInfo.type === UserTypes.IndependentContractor;
  },
  isTenantAndOwner: (state: IUserState): boolean => {
    return state.userInfo.type === UserTypes.Owner
      || state.userInfo.type === UserTypes.Tenant
      || state.userInfo.type === UserTypes.SimpleUser;
  },
  userCrudActionStatus : (state: IUserState) => state.crudActionStatus,
  userActionType : (state: IUserState) => state.actionType,
  user: (state: IUserState) => {
    return state.user
  }
}



// WEBPACK FOOTER //
// ./src/store/user/user-getters.store.ts